export default __webpack_public_path__ + "static/media/closeIcon.e8ebd2a6.svg";